<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rat1PS/tc-custom/9781504051521.jpg?1709153590100" alt="This image is the cover for the book Puzzle for Puppets, The Peter Duluth Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Puzzle for Puppets, The Peter Duluth Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>In this mystery from an Edgar Award–winning author, Peter Duluth deals with a case of mistaken identities and murder in World War II San Francisco.</b><br/>  <br/> Patrick Quentin, best known for the Peter Duluth puzzle mysteries, also penned outstanding detective novels from the 1930s through the 1960s under other pseudonyms, including Q. Patrick and Jonathan Stagge. Anthony Boucher wrote: “Quentin is particularly noted for the enviable polish and grace which make him one of the leading American fabricants of the murderous comedy of manners; but this surface smoothness conceals intricate and meticulous plot construction as faultless as that of Agatha Christie.”<br/>  <br/> As the war rages in the Pacific, naval lieutenant Peter Duluth is ecstatic to make port and spend time with his ladylove, Iris. They have little luck finding a room until a brassy blond offers them her hotel suite out of what seems like pure charity. And that’s when Peter’s shore leave starts going sideways.<br/>  <br/> While unwinding in a steam room, Peter’s uniform is stolen. Then, Iris is mistaken several times for her cousin, a local vamp with a very unusual coterie of friends. And things hit a bloody head when Peter’s missing uniform ends up implicating him in murder.<br/>  <br/> Now, with both of their identities in flux, Peter and Iris must navigate their way through the fog-shrouded alleys of the City by the Bay if they’re going to learn just what kind of mess they’re caught up in . . . and if they can get out of it alive.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patrick Quentin
      </h2>
      
      <p class="authorDescription body article">Patrick Quentin, Q. Patrick, and Jonathan Stagge were pen names under which Hugh Callingham Wheeler (1912&ndash;1987), Richard Wilson Webb (1901&ndash;1966), Martha Mott Kelley (1906&ndash;2005), and Mary Louise White Aswell (1902&ndash;1984) wrote detective fiction. Most of the stories were written together by Webb and Wheeler, or by Wheeler alone. Their best-known creation is amateur sleuth Peter Duluth. In 1963, the story collection <I>The Ordeal of Mrs. Snow</I> was given a Special Edgar Award by the Mystery Writers of America.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.com/Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?44b6dbe6